/* TASK 62 (Φ4, owner-directed Σ07-10): Greeklish → ελληνικά για την αναζήτηση.
 * Στρατηγική resolve():
 *   1. Δοκιμάζεται ΠΡΩΤΑ το αυτούσιο query (brands/SKU: «casio», «EGS…» δουλεύουν ήδη).
 *   2. Αν 0 αποτελέσματα ΚΑΙ το query είναι λατινικό → παράγονται ελληνικά variants
 *      (κύρια μεταγραφή + single-flip στα διφορούμενα: i→ι/η/υ, e→ε/αι, o→ο/ω,
 *      h→η/χ, u→υ/ου, d→δ/ντ, b→μπ/β, x→χ/ξ, y→υ/ι, w→ω/β) και δοκιμάζονται
 *      σειριακά στο predictive API μέχρι το πρώτο με αποτελέσματα.
 * Καταναλωτές: search panel (header) + /search zero-results redirect.
 * Μελλοντικά (owner): αγγλικά↔ελληνικά αμφίδρομα + βαθύτερο typo-fuzzy.
 */
(function () {
  var DIGRAPHS = [
    ['th', 'θ'], ['ps', 'ψ'], ['ks', 'ξ'], ['ph', 'φ'], ['ch', 'χ'],
    ['gk', 'γκ'], ['gg', 'γγ'], ['mp', 'μπ'], ['nt', 'ντ'], ['ts', 'τσ'],
    ['tz', 'τζ'], ['ou', 'ου'], ['ai', 'αι'], ['ei', 'ει'], ['oi', 'οι'],
    ['au', 'αυ'], ['eu', 'ευ']
  ];
  var SINGLES = {
    a: 'α', b: 'μπ', c: 'κ', d: 'δ', e: 'ε', f: 'φ', g: 'γ', h: 'η', i: 'ι',
    j: 'ζ', k: 'κ', l: 'λ', m: 'μ', n: 'ν', o: 'ο', p: 'π', q: 'κ', r: 'ρ',
    s: 'σ', t: 'τ', u: 'υ', v: 'β', w: 'ω', x: 'χ', y: 'υ', z: 'ζ'
  };
  var ALT = {
    i: ['η', 'υ'], e: ['αι'], o: ['ω'], h: ['χ'], u: ['ου'],
    y: ['ι'], d: ['ντ'], b: ['β'], x: ['ξ'], w: ['β']
  };
  var MAX_VARIANTS = 7;

  function isLatin(q) {
    return /[a-z]/i.test(q) && !/[Ͱ-Ͽ]/.test(q);
  }

  // Σύγκριση χωρίς τόνους/πεζά (ελληνικά + λατινικά)
  function grNorm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ς/g, 'σ');
  }

  // TASK 62γ (owner Σ07-10): SKU-detection — κωδικοί = ΧΩΡΙΣ fuzzy/greeklish.
  // Μοτίβο: ≥4 chars, χωρίς κενά/ελληνικά, λατινικά+ψηφία+.-/ και ≥2 ψηφία
  // (CS0203.014, EGS3074040, NH8391-51AE, 1710552 ✓ — «casio», «ρολ» ✗)
  function looksLikeSku(q) {
    q = q.trim();
    return q.length >= 4 && !/\s/.test(q) && /^[A-Za-z0-9.\-\/]+$/.test(q) && /\d{2,}/.test(q);
  }

  function translitVariants(q) {
    q = q.toLowerCase();
    var out = [];
    var ambiguous = []; // {idx, options[]} — θέσεις για single-flip variants
    var i = 0;
    while (i < q.length) {
      var two = q.slice(i, i + 2);
      var hit = null;
      for (var d = 0; d < DIGRAPHS.length; d++) {
        if (DIGRAPHS[d][0] === two) { hit = DIGRAPHS[d][1]; break; }
      }
      if (hit) { out.push(hit); i += 2; continue; }
      var c = q[i];
      if (SINGLES[c]) {
        out.push(SINGLES[c]);
        if (ALT[c]) ambiguous.push({ idx: out.length - 1, options: ALT[c] });
      } else {
        out.push(c);
      }
      i++;
    }
    var variants = [out.join('')];
    for (var a = 0; a < ambiguous.length && variants.length < MAX_VARIANTS; a++) {
      for (var o = 0; o < ambiguous[a].options.length && variants.length < MAX_VARIANTS; o++) {
        var arr = out.slice();
        arr[ambiguous[a].idx] = ambiguous[a].options[o];
        variants.push(arr.join(''));
      }
    }
    return variants;
  }

  function excludedHandles() {
    return (window.__searchExcluded && window.__searchExcluded.length) ? window.__searchExcluded : [];
  }

  // TASK 62ε: ντετερμινιστικό index συλλογών (/collections.json, δημόσιο) —
  // η αναγνώριση «query = κατηγορία» ΔΕΝ βασίζεται στο accent-folding του
  // predictive (αναξιόπιστο: «κολιε» ✓ αλλά «ρολογια» ✗ — τόνος μεσολέξεως).
  var collPromise = null;
  function loadCollections() {
    if (collPromise) return collPromise;
    collPromise = (function fetchPage(page, acc) {
      return fetch('/collections.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var cs = (j && j.collections) || [];
          /* Σ07-12 owner-bug: άδειες συλλογές (products_count 0) ΕΞΩ από το index —
             ποτέ redirect/πρόταση σε συλλογή χωρίς προϊόντα (κανόνας Φ4: ό,τι
             εμφανίζεται → ≥1 προϊόν). 209 άδειες μετρήθηκαν στον κατάλογο. */
          /* + Σ07-12: κρυφές συλλογές (influencer, window.__hiddenCollections) ΕΞΩ */
          var hidden = window.__hiddenCollections || [];
          acc = acc.concat(cs.filter(function (c) {
            return (c.products_count || 0) > 0 && hidden.indexOf(c.handle) === -1;
          }).map(function (c) {
            return { title: c.title, url: '/collections/' + c.handle, norm: grNorm(c.title) };
          }));
          return (cs.length === 250 && page < 5) ? fetchPage(page + 1, acc) : acc;
        });
    })(1, []).catch(function () { collPromise = null; return []; });
    return collPromise;
  }

  // query ≡ τίτλος συλλογής (χωρίς τόνους/πεζά, + greeklish μεταγραφές)
  function collectionHit(raw) {
    var targets = [grNorm(raw)];
    if (isLatin(raw)) {
      translitVariants(raw).forEach(function (v) { targets.push(grNorm(v)); });
    }
    return loadCollections().then(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (targets.indexOf(list[i].norm) !== -1) return list[i];
      }
      return null;
    });
  }

  // TASK 62γ: variants.sku ΡΗΤΑ στα searched fields — το predictive API ΔΕΝ
  // ψάχνει SKU by default (ρίζα του «CS0203.014 = κανένα προτεινόμενο» bug)
  var SUGGEST_FIELDS = 'title,product_type,variants.title,variants.sku,vendor,tag';

  function suggest(q, signal) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=4&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=' + SUGGEST_FIELDS,
      signal ? { signal: signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var res = (j && j.resources && j.resources.results) || {};
        // TASK 62β: κρυφά βοηθητικά προϊόντα (π.χ. επέκταση εγγύησης) — έξω
        var ex = excludedHandles();
        if (ex.length && res.products) {
          res.products = res.products.filter(function (p) { return ex.indexOf(p.handle) === -1; });
        }
        var count = (res.products || []).length + (res.collections || []).length + (res.queries || []).length;
        return { query: q, results: res, count: count };
      });
  }

  // Owner-bug Σ07-10: το άτονο «κολιε» στο ΠΛΗΡΕΣ /search ≠ «κολιέ» (11 vs
  // εκατοντάδες αποτελέσματα) — το predictive κάνει accent-folding, το full
  // search ΟΧΙ. Κανονικοποίηση: αν κάποιο query-completion του predictive
  // ισούται χωρίς-τόνους με το query μας → χρησιμοποιείται ΑΥΤΟ (το πραγματικό
  // τονισμένο term του καταλόγου) για CTA/submit.
  function canonicalize(r) {
    if (looksLikeSku(r.query)) return r; // SKU: ποτέ αλλοίωση
    var target = grNorm(r.query);
    // greeklish: σύγκρινε ΚΑΙ τη μεταγραμμένη μορφή («rologia» ↔ «Ρολόγια» —
    // το raw μπορεί να έχει αποτελέσματα από tags/handles και να μην τρέξει translit)
    var target2 = isLatin(r.query) ? grNorm(translitVariants(r.query)[0]) : null;
    function normHit(s) {
      var n = grNorm(s);
      return n === target || (target2 && n === target2);
    }
    // Owner-αρχή Σ07-10: query που ΕΙΝΑΙ κατηγορία («ρολόγια», «κολιέ») → η ίδια
    // η συλλογή = το καλύτερο αποτέλεσμα (ΟΛΑ τα προϊόντα + φίλτρα)· το full
    // search θα έδινε υποσύνολο (ρολόγια* = 25 vs χιλιάδες στη συλλογή).
    var colls = (r.results && r.results.collections) || [];
    /* Σ07-12 (3ο μονοπάτι, probe-reproduced): και το Enter-redirect φιλτράρει τις
       κρυφές συλλογές — αλλιώς title-match («Σκουλαρίκια») οδηγούσε στην influencer */
    var hiddenC = window.__hiddenCollections || [];
    for (var c = 0; c < colls.length; c++) {
      var ch = ((colls[c].url || '').split('?')[0].split('/collections/')[1] || '').replace(/\/$/, '');
      try { ch = decodeURIComponent(ch); } catch (e) { /* as-is */ }
      if (hiddenC.indexOf(ch) !== -1) continue;
      if (normHit(colls[c].title)) {
        r.query = colls[c].title;
        r.collectionUrl = (colls[c].url || '').split('?')[0]; // κόψε τα _pos tracking params
        return r;
      }
    }
    // αλλιώς: κανονικοποίηση στο πραγματικό τονισμένο term (query-completions)
    var qs = (r.results && r.results.queries) || [];
    for (var i = 0; i < qs.length; i++) {
      if (normHit(qs[i].text) && qs[i].text !== r.query) {
        r.query = qs[i].text;
        break;
      }
    }
    return r;
  }

  function resolve(raw, signal) {
    raw = raw.trim();
    // SKU: ΠΟΤΕ fuzzy/greeklish/κατηγοριοποίηση (owner: 1 χαρακτήρας = άλλο προϊόν)
    if (looksLikeSku(raw)) return suggest(raw, signal);
    return Promise.all([suggest(raw, signal), collectionHit(raw)]).then(function (pair) {
      var first = pair[0];
      var hit = pair[1];
      if (hit) {
        // κατηγορία: query = ο τίτλος της συλλογής + redirect στη συλλογή·
        // αν το raw δεν έδωσε προϊόντα (greeklish/άτονο) πάρε κάρτες από τον τίτλο
        var base = first.count > 0
          ? Promise.resolve(first)
          : suggest(hit.title, signal).catch(function () { return first; });
        return base.then(function (r) {
          r.query = hit.title;
          r.collectionUrl = hit.url;
          if ((r.results.products || []).length > 0) return r;
          // ούτε ο τίτλος έδωσε κάρτες (π.χ. «Ρολόγια» vs τίτλοι «Ρολόι…») →
          // δείγμα προϊόντων από την ΙΔΙΑ τη συλλογή (δημόσιο products.json)
          return fetch(hit.url + '/products.json?limit=3')
            .then(function (pr) { return pr.json(); })
            .then(function (j) {
              r.results.products = ((j && j.products) || []).map(function (p) {
                return {
                  handle: p.handle,
                  title: p.title,
                  url: '/products/' + p.handle,
                  price: (p.variants && p.variants[0] && p.variants[0].price) || '',
                  featured_image: { url: (p.images && p.images[0] && p.images[0].src) || '' }
                };
              });
              r.count = r.count + r.results.products.length;
              return r;
            })
            .catch(function () { return r; });
        });
      }
      if (first.count > 0 || !isLatin(raw)) return canonicalize(first);
      var vars = translitVariants(raw);
      function tryAt(ix) {
        if (ix >= vars.length) return first; // τίποτα δεν βρέθηκε — γύρνα το raw
        return suggest(vars[ix], signal).then(function (r) {
          return r.count > 0 ? canonicalize(r) : tryAt(ix + 1);
        });
      }
      return tryAt(0);
    });
  }

  // TASK 62γ: επαλήθευση ΑΚΡΙΒΟΥΣ SKU — το predictive κάνει prefix-match,
  // εδώ κρατάμε ΜΟΝΟ προϊόντα με variant.sku === query (case-insensitive)
  function verifyExactSku(raw, products) {
    var target = raw.trim().toUpperCase();
    var picks = (products || []).slice(0, 4);
    if (!picks.length) return Promise.resolve([]);
    return Promise.all(picks.map(function (p) {
      return fetch('/products/' + p.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (full) {
      var exact = [];
      full.forEach(function (f, i) {
        if (f && f.variants && f.variants.some(function (v) { return (v.sku || '').toUpperCase() === target; })) {
          exact.push(picks[i]);
        }
      });
      return exact;
    });
  }

  // TASK 62γ: «παρόμοιοι κωδικοί» όταν ο ακριβής δεν υπάρχει — προοδευτικό
  // κόψιμο του prefix (1710552 → 171055 → βρίσκει 1710551), max 6 δοκιμές
  function skuSimilar(raw, signal) {
    raw = raw.trim();
    var tries = 0;
    function attempt(len) {
      if (len < 4 || tries >= 6) return Promise.resolve(null);
      tries++;
      var prefix = raw.slice(0, len);
      return suggest(prefix, signal).then(function (r) {
        var prods = (r.results && r.results.products) || [];
        if (prods.length) return { prefix: prefix, products: prods };
        return attempt(len - 1);
      });
    }
    return attempt(raw.length - 1);
  }

  window.SearchIntel = {
    isLatin: isLatin,
    looksLikeSku: looksLikeSku,
    translitVariants: translitVariants,
    suggest: suggest,
    resolve: resolve,
    verifyExactSku: verifyExactSku,
    skuSimilar: skuSimilar
  };

  // prefetch του index συλλογών σε idle — το πρώτο resolve να μην πληρώνει
  // τα ~2×250 paginated fetches (latency στο πρώτο άνοιγμα του panel)
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () { loadCollections(); }, { timeout: 5000 });
  } else {
    setTimeout(loadCollections, 3000);
  }
})();
